/**
 * Diretiva de máscara genérica em campo de texto.
 *
 * @author Márcio Casale de Souza <contato@kazale.com>
 * @since 0.0.4
 */

import { Directive, HostListener, Input } from '@angular/core';
import {
  NG_VALUE_ACCESSOR, ControlValueAccessor
} from '@angular/forms';

@Directive({
  selector: '[appKzMask]',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: KzMaskDirective,
    multi: true
  }]
})
export class KzMaskDirective implements ControlValueAccessor {

  onTouched: any;
  onChange: any;

  @Input('appKzMask') kzMask: string;

  writeValue(value: any): void {
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  @HostListener('keyup', ['$event'])
  onKeyup($event: any) {

    let valor = $event.target.value.replace(/\D/g, '');
    const pad = this.kzMask.replace(/\D/g, '').replace(/9/g, '_');
    const valorMask = valor + pad.substring(0, pad.length - valor.length);

    // retorna caso pressionado backspace
    if ($event.keyCode === 8) {
      this.onChange = valor;
      return;
    }

    if (valor.length <= pad.length) {
      this.onChange = valor;
    }

    let valorMaskPos = 0;
    valor = '';
    for (let i = 0; i < this.kzMask.length; i++) {
      if (isNaN(parseInt(this.kzMask.charAt(i)))) {
        valor += this.kzMask.charAt(i);
      } else {
        valorMaskPos++;
        valor += valorMask[valorMaskPos];
      }
    }

    if (valor.indexOf('_') > -1) {
      valor = valor.substr(0, valor.indexOf('_'));
    }

    $event.target.value = valor;
  }

  @HostListener('blur', ['$event'])
  onBlur($event: any) {
    if ($event.target.value.length === this.kzMask.length) {
      if (!this.ValidarCPF($event.target.value)) {
        console.log('CPF Invalido!');
      } else {
        console.log('CPF Valido!');
      }
    }
  }

  ValidarCPF(cpf: string) {
    const exp = /\.|\-/g;
    const strCPF = cpf.toString().replace(exp, '');

    const digitoDigitado = parseInt(strCPF.charAt(9), 10) + parseInt(strCPF.charAt(10), 10);

    let soma1 = 0, soma2 = 0;
    let vlr = 11;

    for (let i = 0; i < 9; i++) {
      const cod: number = +strCPF.charAt(i);
      soma1 += cod * (vlr - 1);
      soma2 += cod * vlr;
      vlr--;
    }

    soma1 = (((soma1 * 10) % 11) === 10 ? 0 : ((soma1 * 10) % 11));
    soma2 = (((soma2 + (2 * soma1)) * 10) % 11);

    const digitoGerado = (soma1 * 10) + soma2;

    if (digitoGerado !== +digitoDigitado) {
      return false;
    }

    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/kz-mask.directive.ts